<template>
  <div class="min-h-dvh relative overflow-y-auto bg-linear-to-br from-slate-900 via-purple-950 to-slate-900">
    <BaseGlowBackground />

    <slot />
  </div>
</template>
